<template>
    <AuthCard v-if="visible" title="Sign In">
        <UForm :state="form" :schema="r$" @submit="submit">
            <ValidationSummary :errors="authCodeErrors"/>
            <ValidationSummary :errors="authErrors"/>
            <UFormField name="email">
                <UInput v-model="form.email" placeholder="Email" autocomplete="username" />
            </UFormField>
            <UFormField name="password">
                <UInput v-model="form.password" type="password" placeholder="Password" autocomplete="current-password" />
                <template #hint>
                    <ULink to="/forgot-password" class="text-primary font-medium" tabindex="-1">Forgot password?</ULink>
                </template>
            </UFormField>
            <UFormField name="rememberMe">
                <UCheckbox v-model="form.rememberMe" label="Remember Me" />
            </UFormField>
            <UButton type="submit" block :loading="loading">Continue</UButton>
        </UForm>
        <!-- <USeparator>or</USeparator>
        <div class="space-y-3">
            <UButton
                block
                color="neutral"
                variant="subtle"
                icon="i-simple-icons-github"
                @click="signInProvider('GitHub')"
                >GitHub</UButton
            >
        </div> -->
        <template #footer>
            <ULink to="/forgot-password" class="text-primary font-medium" tabindex="-1">Forgot password?</ULink>
        </template>
    </AuthCard>
</template>

<script setup lang="ts">
    import { required, email } from '@regle/rules';

    import AuthCard from './components/AuthCard.vue';

    definePageMeta({
        layout: 'auth',
    });

    const route = useRoute();
    const auth = useAuth();

    const visible = ref(false); // To avoid page flickering while exchanging authorizationCode to token

    const form = shallowReactive({
        email: '',
        password: '',
        rememberMe: false,
    });

    const rules = {
        email: { required, email },
        password: { required },
    };

    const { r$, errors: authErrors, loading, submit } = useForm(form, rules, onSubmit);

    const { errors: authCodeErrors } = useAuthorizationCodeHandler(() => (visible.value = true));

    function getAfterLoginRedirect() {
        return route.query.redirect?.toString() || '/';
    }

    async function onSubmit() {
        await auth.signIn(form.email, form.password, form.rememberMe, getAfterLoginRedirect());
    }

    async function signInProvider(provider: string) {
        try {
            await auth.signInProvider(provider);
        } catch (error) {
            authErrors.value = getBadRequestErrorsOrThrow(error);
        }
    }
</script>
